import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClockAlternative20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconClockAlternative20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m1.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0M8.163 9.207l-1.427-1.41A.75.75 0 1 1 7.79 6.728l1.44 1.425a2 2 0 0 1 1.581.019l2.433-2.433a.75.75 0 0 1 1.061 1.06l-2.451 2.452a2 2 0 1 1-3.691-.044M10.5 10a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClockAlternative20);
